import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject, tap } from 'rxjs';
import { APIRequestResources, CachedAPIRequest, LoadingService } from 'src/app/core';
import { MachineHoldDataDTO } from '../interfaces/machine-time.entity';

@Injectable({
  providedIn: 'root'
})
export class MachineTimeService extends CachedAPIRequest {

  constructor(protected override http: HttpClient, private router: Router) {
      super(http, APIRequestResources.MachineTimeService)
  }

  loading = inject(LoadingService);
  private refreshTrigger = new Subject<void>();

  $active = new BehaviorSubject<any | undefined>(undefined);
  active = toSignal(this.$active, {initialValue: undefined});

  findHoldReasonsByMachine = (id:number, searchParams:any, refresh = true) => {
    this.loading.set(true, {immediate: true});
    return this.get<MachineHoldDataDTO>({suffix: `hold-reasons/${id}` ,params: searchParams},
      refresh ? 'freshness' : 'performance'
    ).pipe(
      tap((res) => {
        this.$active.next(res.data)
      })
    )
  }

}
